<template>
    <v-dialog
        v-model="show"
        @click:outside="close"
        width="500"
    >
        <v-card v-if="transfer">
            <v-toolbar color="primary" dark flat>
                <v-toolbar-title class="text-capitalize">Transfer memo</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="pt-8 pb-0">
                <v-textarea
                    outlined
                    label="Memo"
                    v-model="memo"
                ></v-textarea>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    class="px-6"
                    text
                    color="red darken-2"
                    large
                    @click="close"
                >
                    Cancel
                </v-btn>
                <v-btn
                    class="px-6"
                    color="primary"
                    dark
                    depressed
                    large
                    @click="save"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        transfer: Object,
    },
    data() {
        return {
            memo: null,
        };
    },
    mounted() {
        this.memo = this.transfer ? this.transfer.memo : null;
    },
    watch: {
        transfer: function (transfer) {
            this.memo = transfer ? transfer.memo : null;
        },
    },
    computed: {
        show: {
            get() {
                return !!this.transfer;
            },
            set(val) {
                if (!val) {
                    this.close();
                }
            }
        }
    },
    methods: {
        async save() {
            const { user } = this.$store.state;
            const { id } = this.transfer;
            const { memo } = this;

            try {
                this.$emit('loading');

                if (this.transfer.order_id) {
                    await Vue.backendApi().pendingMatches(id).updateMemo({ memo });
                } else {
                    await Vue.backendApi().order(id).updateMemo({ memo });
                }

                Vue.set(this.transfer, 'memo', memo);
                this.close();
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error updating memo',
                    text: err
                });
            } finally {
                this.$emit('loaded');
            }
        },
        close() {
            this.$emit('update:transfer', null);
        },
    },
};
</script>
